module.exports = __webpack_public_path__ + "img/mp4Icon.e23a3cc5.png";